<template>
    <div class="login-wrap" :style="bgStyle"  v-loading="loading2" element-loading-text="正在加载" element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(255, 255, 255, 1)" >
        <div class='loginDiv' ref="loginDiv">
            <el-backtop target=".loginDiv"></el-backtop>
            <div class='chmHeader' ref="chmHeader">
                <div class='fl20'>
                    <p class='chmTitle'><img :src="content.station.stationLogo" class='title-logo' />{{content.station.stationName}}</p>
                </div>
                <div class='fl65'>
                    <el-menu default-active="1" class="el-menu-group0" mode="horizontal" @select="scrollToSection" >
                        <el-menu-item class='el-menu-group0-item' index="1">首页</el-menu-item>
                        <el-menu-item class='el-menu-group0-item' index="2">优秀员工</el-menu-item>
                        <el-menu-item class='el-menu-group0-item' index="4">合作伙伴</el-menu-item>
                        <el-menu-item class='el-menu-group0-item' index="3">常见问题</el-menu-item>
                        <el-menu-item class='el-menu-group0-item' index="5">联系我们</el-menu-item>
                    </el-menu>
                </div>
                <div class='fl15 chmBtnDiv'>
                    <el-button type="primary"  class='chmBtn'  @click="login" >登录</el-button>
                </div>
            </div>
            <div class='chmBanner' id="section-1">
                <el-carousel :interval="3000" >
                    <el-carousel-item class='chmBannerList'  v-for="item in content.banner" :key="item">
                        <img :src='item.img' >
                    </el-carousel-item>
                </el-carousel>
            </div>
            <!-- 数据统计 -->
            <div class='chmBannerTop'>
                <img :src='top_left' class='top_left' />
                <p class='top_center'></p>
                <img :src='top_right' class='top_right' />
            </div>
            <div style='clear:both'></div>
            <div class='chmData' id="section-2">
                <div class='chmLoginTitle'>优秀员工</div>
                <div class='chmDataContent'>
                    <div class='chmDataItem flip-card fl' v-for="(item, index) in content.userbetter" :key="index">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <img :src='item.img'>
                            </div>
                            <div class="flip-card-back">
                                <div class='chmDataItemTitle'>{{ item.title }}</div>
                                <div class='chmDataItemContent'>{{ item.message }}</div>
                            </div>
                        </div>
                        <el-rate class='chmDataItemRate' disabled='true' style='margin-top:6px;' v-model.trim="item.rate"></el-rate>
                    </div>
                    <div style='clear:both'></div>
                </div>
            </div>
            <div class='chmParnter' id="section-4">
                <div class='chmLoginTitle'>合作伙伴</div>
                <div class="parnter-container">
                    <div class='chmParnterCard flip-card' v-for="(item, index) in content.parnter" :key="index">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <img :src='item.img' />
                            </div>
                            <div class="flip-card-back">
                                <div class='chmDataItemTitle'>{{ item.title }}</div>
                                <div class='chmDataItemContent'>{{item.message}}</div>
                            </div>
                        </div>

                    </div>
                </div>
                <div style='clear:both'></div>
            </div>
            <div class='chmNews' id="section-3">
                <div class='chmLoginTitle'>常见问题</div>
                <el-collapse v-model="content.activeNews" >
                    <el-collapse-item class='chmNewsItem' v-for='(item,index) in content.news'>
                        <template slot="title">
                            <div class='el-collapse-title'> <i class="el-icon-lx-notificationfill"></i>{{ item.title }}</div>
                        </template>
                        <div class='el-collapse-content' v-html='item.content'></div>
                    </el-collapse-item>
                </el-collapse>
            </div>

            <div class='chmJoinUs' id="section-5">
                <div class='chmLoginTitle'>联系我们</div>
                <div class='chmJoinUsDiv chmJoinUsDiv1'>
                    <div class='chmJoinUsItem'>
                        <div class='chmJoinUsItemTitle'>公司名称</div>
                        <div class='chmJoinUsItemContent'>{{content.station.companyName}}</div>
                    </div>
                    <div class='chmJoinUsItem'>
                        <div class='chmJoinUsItemTitle'>公司地址</div>
                        <div class='chmJoinUsItemContent'>{{content.station.companyArea}}</div>
                    </div>
                    <div class='chmJoinUsItem'>
                        <div class='chmJoinUsItemTitle'>联系电话</div>
                        <div class='chmJoinUsItemContent'>{{content.station.companyPhone}}</div>
                    </div>
                    <div class='chmJoinUsItem'>
                        <div class='chmJoinUsItemTitle'>公司邮箱</div>
                        <div class='chmJoinUsItemContent'>{{content.station.companyEmail}}</div>
                    </div>
                    <div class='chmJoinUsItem'>
                        <div class='chmJoinUsItemTitle'>公司网址</div>
                        <div class='chmJoinUsItemContent'>{{content.station.stationUrl}}</div>
                    </div>
                </div>
                <div class='chmJoinUsDiv chmJoinUsDiv2'>
                    <div class='chmJoinUsDivImg qrcode-container'>
                        <img class='linkImg' :src="content.station.linkUrl">
                        <div class="scan-line"></div>
                        <div class="scan-light"></div>
                    </div>
                </div>
                <div style='clear:both'></div>
            </div>
            <div class='chmFooter'>
                <div class="footer-wave"></div>
                <img src='../../../assets/img/icp.png'>{{content.station.companyIsp}}</div>

            <el-dialog :close-on-click-modal="false" title="登录" style='left:50%;top:8%;' :modal-append-to-body='false' :close-on-press-escape="false" :visible.sync="loginVisible" width="400px" class="animated-dialog">
                <div style='padding:0 20px;'>
                    <el-form :model="inputData" :rules="rules" ref="login" label-width="0px" class="ms-content">
                        <div class="user-type-selector">
                            <div class="radio-group-container">
                                <div class="radio-option qds-radio-option" :class="{ 'active': inputData.userType === '2' }" @click="userTypeAction('2')">
                                    <i class="el-icon-user-solid"></i>
                                    <span> 渠道商登录 </span>
                                </div>
                                <div class="radio-option user-radio-option" :class="{ 'active': inputData.userType === '1' }" @click="userTypeAction('1')">
                                    <i class="el-icon-user"></i>
                                    <span>员 工 登 录</span>
                                </div>
                            </div>
                        </div>
                        <span class="label-span">
                            <label class="label">手机号码</label>
                            <el-input v-model.trim="inputData.phone" style="width:220px" oninput="value=value.replace(/[^\d]/g,'')" @input="getCode" placeholder="手机号码" ></el-input>
                        </span>
                        <br><br>
                        <span class="label-span">
                            <label class="label">登录密码</label>
                            <el-input type='password' v-model.trim="inputData.password" style="width:220px" placeholder="登录密码" ></el-input>
                        </span>
                        <br><br>
                        <span class="label-span">
                            <label class="label">验证码</label>
                            <el-input v-model.trim="inputData.code" style="width:220px" @keyup.enter.native="submitForm" placeholder="验证码" class="code"></el-input>
                            <img  @click="getCode" :hidden="param.show" class="imgCode" :src="param.imgCode" />
                        </span><br><br><br>
                        <div class="login-btn">
                            <el-button style='width: 100%;height: 40px;font-size: 16px;border-radius: 5px;' @click.prevent="submitForm">登录</el-button>
                        </div>
                        <br><br>
                    </el-form>
                </div>
            </el-dialog>


            <!--<div :hidden="loadLayer" style="background-color:#000;width:100%;height:100%;opacity:0.5;">
                <i class="el-icon-loading" style="color:#ddd;font-size:80px;position:absolute;float:left;left: 50%; top: 50%;  margin: -110px 0 0 -40px;"></i>
            </div> -->
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { login } from './login';
import { getImgCode,getStationByLogin,getContent} from '../../../api/common';

export default {
    data: function() {
        return {
            scrolled:false,
            code:'',
            sysHidden:true,
            top_left:require('/src/assets/img/top_left.png') ,
            top_right:require('/src/assets/img/top_right.png') ,
            logo:'',
            //loadLayer:true,
            param: {
                imgCode:'',
                stationName:"",
                stationId:"",
                stationLogo:"",
                show:true,
            },
            content:{
                banner:[],
                parnter:[],
                news:[],
                activeNews:[],
                userbetter:[],
                station:'',
            },
            inputData:{
                phone: '',
                password: '',
                code:'',
                userType:'1',
            },
            select:{ option:'',  },
            data:{checkCode:''},
            coverImgUrl:'',
            loginVisible:true,
            loading:false,
            loading2:true,
            loginHidden:true,
            stationName:"",
            indexUrl:'',
            rules: {
                phone: [{ required: true, message: '手机号', trigger: 'blur' }],
                password: [{ required: true, message: '密码', trigger: 'blur' }],
                code: [{ required: true, message: '验证码', trigger: 'blur' }],
            },

        };

    },
    beforeCreate(){
    },
    created(){
        this.getStationInfo();
    },
    beforeDestroy() {
        // 移除事件监听
        this.$refs.loginDiv.removeEventListener('scroll', this.handleScroll);
    },
    mounted() {
        this.getLoginContent();
        this.$refs.loginDiv.addEventListener('scroll', this.handleScroll);
        this.$nextTick(() => {
            this.initParticles();
            window.addEventListener('resize', this.initParticles);
        });
    },
    computed:{
        bgStyle(){
            return {
                backgroundImage: 'url(' + this.coverImgUrl + ')'
            }
        }
    },
    methods: {
        initParticles() {
            const canvas = document.getElementById('particlesCanvas');
            if (!canvas) return;

            const ctx = canvas.getContext('2d');
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;

            const particles = [];
            const particleCount = 80;

            // 创建粒子
            for (let i = 0; i < particleCount; i++) {
                particles.push({
                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height,
                    radius: Math.random() * 3 + 1,
                    speedX: Math.random() * 1 - 0.5,
                    speedY: Math.random() * 1 - 0.5,
                    color: `rgba(0, 150, 255, ${Math.random() * 0.5 + 0.1})`
                });
            }

            // 动画函数
            const animate = () => {
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                particles.forEach(p => {
                    p.x += p.speedX;
                    p.y += p.speedY;

                    // 边界检测
                    if (p.x < 0 || p.x > canvas.width) p.speedX *= -1;
                    if (p.y < 0 || p.y > canvas.height) p.speedY *= -1;

                    // 绘制粒子
                    ctx.beginPath();
                    ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
                    ctx.fillStyle = p.color;
                    ctx.fill();

                    // 绘制粒子间的连线
                    particles.forEach(p2 => {
                        const dx = p.x - p2.x;
                        const dy = p.y - p2.y;
                        const distance = Math.sqrt(dx * dx + dy * dy);

                        if (distance < 150) {
                            ctx.beginPath();
                            ctx.strokeStyle = `rgba(0, 150, 255, ${0.1 * (1 - distance/150)})`;
                            ctx.lineWidth = 0.5;
                            ctx.moveTo(p.x, p.y);
                            ctx.lineTo(p2.x, p2.y);
                            ctx.stroke();
                        }
                    });
                });

                requestAnimationFrame(animate);
            };

            animate();
        },
        scrollToSection(index) {
            const element = document.getElementById('section-'+index);
            if (element) {
                const offset = 65;
                const topPos = element.offsetTop - offset;

                this.$refs.loginDiv.scrollTo({
                    top: topPos,
                    behavior: 'smooth'
                });
            }
        },
        userTypeAction(userType){
            this.inputData.userType = userType;
            this.getCode();
        },
        // 新增滚动处理函数
        handleScroll() {
            if(window.screen < 500){
                return;
            }
            const header = this.$refs.chmHeader;
            const menuItems = this.$el.querySelectorAll(".el-menu-group0-item");

            if (this.$refs.loginDiv.scrollTop > 60) {
                header.style.background = "rgba(255,255,255,0.95)";
                header.style.boxShadow = "0 2px 10px rgba(0,0,0,0.1)";
                header.style.color = "#333";
                menuItems.forEach(item => {
                    item.classList.add("scrolled");
                    item.classList.remove("transparent");
                });
            } else{
                header.style.background = "rgba(0,0,0,0.2)";
                header.style.boxShadow = "none";
                header.style.color = "#ddd";
                menuItems.forEach(item => {
                    item.classList.add("transparent");
                    item.classList.remove("scrolled");
                });
            }
        },
        handleSlideChange(currentIndex) {
            // 确保轮播图持续切换
            const nextIndex = (currentIndex + 1) % this.content.banner.length;

            // 使用 setTimeout 确保切换发生在下一个事件循环
            setTimeout(() => {
                this.$refs.carousel.setActiveItem(nextIndex);
            }, 0);
        },
        getLoginContent(){
            getContent(this.param).then(res => {
                if(res.code==200){
                    this.content.banner = res.data.banner;
                    this.content.parnter = res.data.parnter;
                    this.content.news = res.data.news;
                    this.content.station = res.data.station;
                    this.content.userbetter = res.data.userbetter;
                }else{

                }}
            );
        },
        login(){
            this.loginVisible = true;
        },
        getCode(){
            if(this.inputData.phone.length==11){
                this.getImgCode();
            }
        },

        // 图片验证码
        getImgCode(){
            getImgCode({"phone":this.inputData.phone,"userType":this.inputData.userType}).then(res => {
                if(res.code==200){
                    this.param.imgCode = res.data;
                    this.param.show = false;
                }
            }).catch(err =>{
                this.$message.error('获取图片验证码失败，请刷新页面');
            });


        },

        //查询网站站点信息
        getStationInfo(){
            getStationByLogin({}).then(res => {
                if(res.code==200){
                    this.param.stationId = res.data.st;
                    this.param.stationName = res.data.stationName;
                    this.param.stationLogo = res.data.stationLogo;
                    this.indexUrl = res.data.indexUrl;
                    this.logo = res.data.stationLogo;
                    this.param.stationDescriptions = res.data.stationDescriptions;
                    localStorage.setItem(window.location.hostname+'_stationName', res.data.stationName);
                    localStorage.setItem(window.location.hostname+'_stationLogo', res.data.stationLogo);
                    localStorage.setItem(window.location.hostname+'_stationUrl', res.data.stationUrl);
                    localStorage.setItem(window.location.hostname+'_indexUrl', res.data.indexUrl);
                    localStorage.setItem(window.location.hostname+'_bgPc', res.data.bgPc);
                    document.title = res.data.stationName;
                    document.getElementsByTagName("title")[0].innerText = res.data.stationName;

                    let $favicon = document.querySelector('link[rel="icon"]');
                    if ($favicon !== null) {
                        $favicon.href = res.data.stationLogo;
                    } else {
                        $favicon = document.createElement("link");
                        $favicon.rel = "icon";
                        $favicon.href = res.data.stationLogo;
                        document.head.appendChild($favicon);
                    }
                    let centerWidth = document.documentElement.scrollWidth;
                    /*if(centerWidth<1000){
                        this.coverImgUrl = res.data.bgPhone;
                    }else{
                        this.coverImgUrl = res.data.bgPc;
                    }*/
                    this.loginHidden = false;
                    this.loading2 = false;
                }else{
                    this.loginHidden = false;
                    this.loading2 = false;
                    this.$message.error(res.message);
                }
            }).catch(err =>{
                this.$message.error('获取服务器数据失败，请刷新页面');
            });
        },

        //忘记密码
        resetPass(){
            this.$router.push('/forPass');
            //location.href="http://"+this.indexUrl+"/hk/resetpass?st="+this.param.stationId;
        },
        resetPhone(){
            this.$router.push('/forPhone');
            //location.href="http://"+this.indexUrl+"/hk/resetpass?st="+this.param.stationId;
        },
        submitForm() {
            this.$refs.login.validate(valid => {
                if (valid) {
                    if(!this.inputData.phone){
                        this.$message.error('请输入手机号');
                        return;
                    }
                    if(this.inputData.phone.length!=11){
                        this.$message.error('手机号长度不正确');
                        return;
                    }
                    if(!this.inputData.password){
                        this.$message.error('请输入密码');
                        return;
                    }
                    if(!this.inputData.code){
                        this.$message.error('请输入图形验证码');
                        return;
                    }
                    this.loading = true;
                    login(this.inputData).then(res => {
                        if(res.code=='200'){
                            localStorage.setItem(window.location.hostname+'_loginName', res.data.loginName);
                            localStorage.setItem(window.location.hostname+'_phone', this.inputData.phone);
                            localStorage.setItem(window.location.hostname+'_mid', res.data.id);
                            localStorage.setItem(window.location.hostname+'_avatar', res.data.avatar);
                            localStorage.setItem(window.location.hostname+'_rcode', res.data.rcode);
                            //储存token
                            localStorage.setItem(window.location.hostname+'_token', res.data.id+"@"+res.data.secret+"@"+res.data.rcode+"@"+this.inputData.userType);
                            this.loading = false;
                            if(res.data.rcode=='e821994f324b'){
                                this.$router.push('/welcome');
                            }else if(res.data.rcode=='c00f5b03daee'){
                                this.$router.push('/comOrder2');
                            }else{
                                this.$router.push('/dataNav');
                            }

                            this.$store.commit('setPassword', this.inputData.password);
                            this.$store.commit('setLockState', false);

                            this.$message({
                                showClose: true,
                                message: '登录成功',
                                type: 'success',
                                duration:1000
                            });
                        }else{
                            this.getImgCode();
                            this.loading = false;
                            this.$message.error(res.message);
                        }
                    });

                } else {
                    this.$message.error('请输入登录信息');
                    console.log('error submit!!');
                    return false;
                }
            });
        },
    },
};
</script>
<style>
.loginDiv{
    width: 100%;
    height: 100vh;
    overflow-y: auto;
}
.loginDiv::-webkit-scrollbar  {
    width: 0px;       /* 竖向宽度 */
}
.loginDiv::-webkit-scrollbar-thumb {
    background: #bbb;
    border-radius: 0px; /* 圆角建议≤1px避免溢出 */
}
.loginDiv::-webkit-scrollbar-track{
    background: #fff;
    border-radius: 0px; /* 圆角建议≤1px避免溢出 */
}
.el-menu-group0{
    background:none !important;
    margin-top:10px;
    height: 50px !important;
}
.el-menu-group0 .el-menu-item{
    margin:0 8px !important;
    background:none !important;
    color:#fff;
    font-size: 15px !important;
    border-left:0 !important;
    height: 50px !important;
    line-height: 50px !important;
}
.el-menu-group0 .el-menu-item:hover{
    color:#005EB9FF !important;
    font-size: 16px !important;
    font-weight: 700;
}
.el-menu-group0 .el-menu-item.is-active{
    color:#005EB9FF !important;
    font-weight: 700;
    font-size: 16px !important;
    border-bottom:2px solid #005EB9FF !important;
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 100vh;
    margin: 0;
}
.el-carousel__container{
    height: 100vh;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}
.hkstyle{
    width:400px;
}
.el-input__inner{

    margin-top:5px;
}
.el-select-dropdown__list{
    padding:6px 10px;
}
.chmHeader{
    transition: all 0.4s ease;
    width:100%;
    padding:0 5%;
    height:65px;
    line-height: 65px;
    background: rgba(0, 0, 0, 0.20);
    color:#ddd;
    font-size: 16px;
    box-sizing: border-box;
    z-index: 10002;
    position: fixed;
    top:0;
}
.chmTitle{
    font-size:20px;
}
.chmTitle img{
    width:40px !important;
    height:40px;
    margin-right:10px;
    vertical-align: middle;
    margin-top:-2px;
}
.chmData{
    width:80%;
    padding:50px 10%;
    text-align: center;
    background: #f4f6f9;
}
.chmDataContent{
    width: 100%;
    z-index: 1000;
    position: relative;
    animation: bottomTop 8s infinite;
    -webkit-animation: bottomTop 8s infinite;
    /* 关键设置：仅执行一次 */
    animation-iteration-count: 1;
    animation-delay: 0.5s; /* 延迟2秒后执行 */
    /* 可选：停留在动画结束状态 */
    animation-fill-mode: forwards;
}
@keyframes bottomTop{
    0% {
        margin-top:-100vh;
        transform: scale(1);
    }
    15% {
        margin-top:-80vh;
        transform: scale(1.1);
    }
    35% {
        margin-top:-60vh;
        transform: scale(1.2);
    }
    50% {
        margin-top:-10vh;
        transform: scale(1.0);
    }
    75% {
        margin-top:-60vh;
        transform: scale(1.2);
    }
    95% {
        margin-top:-10vh;
        transform: scale(1.0);
    }
    100% {
        margin-top:40px;
        transform: scale(1.0);
    }
}
/* 3D翻转卡片效果 */
.flip-card {
    perspective: 1000px;
    width: 210px;
    height: 280px;
    display: inline-block;
    margin:20px;
}
.flip-card-front img{
    width: 210px;
    height: 280px;
    border-radius: 12px;
}


.flip-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    transition: transform 0.8s;
    transform-style: preserve-3d;
}

.flip-card:hover .flip-card-inner {
    transform: rotateY(180deg);
}

.flip-card-front, .flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0 8px 16px rgba(0,0,0,0.1);
}
.chmDataItemTitle{
    font-size: 18px;
}
.chmDataItemContent{
    font-size: 15px;
    margin-top:10px;
}
.chmDataItemRate{
    font-size: 45px;
    padding-bottom: 30px;
}
.chmDataItemRate .el-rate__icon{
    font-size:25px !important;
}
.flip-card-front {
    background: linear-gradient(135deg, #005eb9, #1e88e5);
    color: white;
}

.flip-card-back {
    background: linear-gradient(135deg, #1e88e5, #005eb9);
    color: white;
    transform: rotateY(180deg);
}
.chmUl{
    width:100%;
    height:65px;
    line-height: 65px;
    color:#ddd;
    font-size: 16px;
    box-sizing: border-box;
}
.chmUl li{
    list-style: none;
    float:left;
    width:100px;
    text-align: center;
    cursor: pointer;
    margin:0 20px;
}
.chmUl li:hover{
    color:var(--theme_bgcolor);
    border-bottom: 2px solid var(--theme_bgcolor);
}
.chmUl li i{
    font-size: 20px;
}
.chmBtnDiv{
}
.chmBtn{
    width:100px !important;
    height:35px !important;
    font-size: 15px !important;
    border-radius: 18px !important;
}
.chmLoginTitle{
    font-size: 25px;
    color:#333;
    font-weight: 700;
    margin-bottom:15px;
    text-align: center;
}
.chmCompanyHis{
    width:80%;
    padding:50px 10%;
    text-align: left;
    background: #fff;
}
.chmCompanyHisImg{
    display: inline-block;
    width:140px;
}
.chmCompanyHisImg img {
    width:120px;
    vertical-align: bottom;
}
.chmCompanyHisContent{
    width:calc(100% - 150px);
    display: inline-block;
    font-size: 13px;
    color:#666;
    letter-spacing:2px;
}


.chmParnter{
    width:80%;
    padding:50px 10%;
    text-align: center;
    background: #f4f6f9;
}
.parnter-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
}
.chmParnterCard{
    width:120px;
    height: 120px;
    text-align: center;
    display: inline-block;
    transition: all 0.3s ease;
}

.chmParnterCard:hover {
    animation: moveFoot 20s infinite;
    -webkit-animation: moveFoot 20s infinite;
}
@keyframes moveFoot{
    0% {
        opacity: 0.8;
        transform: scale(1);
    }
    10% {
        opacity: 1;
        transform: scale(1.2);
    }
}
.chmParnterCard img {
    width:120px;
    height:120px;
    border-radius: 12px;
}
.chmDetailTitle{
    font-size: 16px;
    margin:10px 0 0 0;
}
.chmNews{
    width: 80%;
    padding:50px 10%;
    background: #fff;
}
.el-collapse-title{
    font-size: 16px;
    font-weight: 500;

}
.chmNewsItem{
    margin:10px 0;
}
.el-collapse-title:hover{
    color:var(--theme_bgcolor);
}
.el-collapse-title i{
    color:var(--theme_bgcolor);
    margin-right:15px;
}
.el-collapse-item__header i{
    font-size: 20px;
    color:var(--theme_bgcolor) !important;
}
.el-collapse-content{
    border-radius: 5px;
    padding:15px 10px;
}
.chmJoinUs{
    width: 80%;
    padding:50px 10%;
    background:#324157;
}
.chmJoinUs .chmLoginTitle{
    color:#fff;
    margin-bottom:85px;
}
.chmJoinUs .chmJoinUsDiv{
    float:left;
    width:49.9%;
}
.chmJoinUs .chmJoinUsDiv1{
    border-right:1px dashed #616a77;
}
.chmJoinUs .chmJoinUsDiv2{
    text-align: center;
}
.chmJoinUsDivImg{
    width:200px;
    height:200px;
    padding:25px;
    border-radius: 25px;
    background: #636e7e;
    display: inline-block;
}
.linkImg{
    width:200px;
    height:200px;
    border-radius: 15px;
}
/* 二维码容器样式 */
.qrcode-container {
    position: relative;
    display: inline-block;
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0 0 20px rgba(0, 150, 255, 0.3);
}

.linkImg {
    display: block;
    width: 200px;
    height: 200px;
    border-radius: 12px;
    transition: all 0.3s ease;
}

/* 扫描线样式 */
.scan-line {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(to right, transparent, #00ff00, transparent);
    box-shadow: 0 0 10px rgba(0, 255, 0, 0.8);
    animation: scanMove 2.5s infinite linear;
    z-index: 10;
}

/* 扫描光效 */
.scan-light {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg,
    rgba(0, 255, 0, 0) 0%,
    rgba(0, 255, 0, 0.05) 20%,
    rgba(0, 255, 0, 0.15) 50%,
    rgba(0, 255, 0, 0.05) 80%,
    rgba(0, 255, 0, 0) 100%);
    pointer-events: none;
    animation: scanLight 3s infinite;
    border-radius: 12px;
    z-index: 5;
}

/* 鼠标悬停效果 */
.qrcode-container:hover .linkImg {
    transform: scale(1.05);
    box-shadow: 0 0 30px rgb(22, 224, 20,0.5);
}

/* 扫描线动画 */
@keyframes scanMove {
    0% {
        top: 0;
    }
    50% {
        top: 100%;
    }
    100% {
        top: 0;
    }
}

/* 扫描光效动画 */
@keyframes scanLight {
    0% {
        opacity: 0.3;
    }
    50% {
        opacity: 0.1;
    }
    100% {
        opacity: 0.3;
    }
}

.chmJoinUsItem{
    color:#ddd;
    height:50px;
    line-height:50px;
}
.chmJoinUsItemTitle{
    float:left;
    width:80px;
    color:#aaa;
    font-size: 15px;
}
.chmJoinUsItemContent{
    float:left;
    color:#ccc;
    font-size: 12px;
}
.chmFooter{
    width: 80%;
    padding:20px 10% 30px;
    background:#000;
    color:#ccc;
    font-size: 12px;
    text-align: center;
}
.chmFooter img{
    vertical-align: middle;
    margin-right:5px;
    margin-top:-2px;
    width:18px;
    height: 18px;
}


/* 对话框动画 */
.animated-dialog {
    animation: dialogAppear 0.3s ease;
}

@keyframes dialogAppear {
    from {
        opacity: 0;
        transform: scale(0.1);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

/* 添加弧形顶部容器 */
.chmData-container {
    position: relative;
    margin-top: -60px;
    overflow: hidden;
}

/* 弧形顶部样式 */
.chmData-top {
    position: absolute;
    top: -60px;
    left: 0;
    width: 100%;
    height: 60px;
    background: #f4f6f9;
    border-radius: 0 0 50% 50%;
    z-index: -1;
}

/* 调整chmData位置 */
/* 修改 .chmData-container 和 .chmData-top 样式 */
.chmData-container {
    position: relative;
    margin-top: -80px; /* 增加负边距使弧形覆盖更自然 */
    overflow: hidden;
}

.chmData-top {
    position: absolute;
    top: -80px; /* 与负边距保持一致 */
    left: 0;
    width: 100%;
    height: 80px; /* 增加高度使弧度更明显 */
    background: linear-gradient(to bottom, #f4f6f9 20%, #e8ecf1 100%); /* 添加渐变 */
    border-radius: 0 0 60% 60%; /* 增大弧度百分比 */
    z-index: -1;
    box-shadow: 0 10px 20px rgba(0,0,0,0.05); /* 添加柔和阴影 */
}

/* 微调数据区域位置 */
.chmData {
    padding-top: 120px; /* 增加顶部内边距 */
    z-index: 98;
    margin-top:-80px;
}
.chmBannerList img{
    width:100%;
    height:100vh;
}
.chmBannerTop{
    width:100%;
    height:100px;
    margin-top: -80px;
    position: relative;
    z-index: 1000;
}
.top_left{
    width:40%;
    height:100px;
    display: inline-block;
    box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.1);
}
.top_center{
    width:20%;
    height:100px;
    display: inline-block;
}
.top_right{
    width:40%;
    height:100px;
    z-index: 1000;
    display: inline-block;
    box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.1);

}
.fl65{
    width:65%;
    float:left;
    border:none;
}
.fl15{
    width:15%;
    text-align: center;
    float:left;
}
.fl20{
    width:20%;
    text-align: center;
    float:left;
}

/* 用户类型选择器样式 */
.user-type-selector {
    margin-bottom: 20px;
    text-align: center;
}

.radio-group-container {
    display: inline-flex;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 25px;
    padding: 4px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
}

.radio-option {
    display: flex;
    align-items: center;
    padding: 12px 22px;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(0, 94, 185, 0.3);
}

.qds-radio-option{
    margin: 0 10px 0 0;
}

.user-radio-option{
    margin: 0 0 0 10px;
}

.radio-option i {
    font-size: 18px;
    margin-right: 8px;
    transition: all 0.3s ease;
}

.radio-option span {
    font-size: 14px;
    color: #7b7d81;
    transition: all 0.3s ease;
}

.radio-option.active {
    background: linear-gradient(135deg, #005eb9, #1e88e5);
}

.radio-option.active i {
    color: #fff;
    transform: scale(1.1);
}

.radio-option.active span {
    color: #fff;
    font-weight: 500;
}

/* 悬停效果 */
.radio-option:not(.active):hover {
    background: rgba(255, 255, 255, 0.05);
}

.radio-option:not(.active):hover i {
    color: #005eb9;
}

/* 移动端适配 */
@media screen and (max-width: 500px) {
    .radio-group-container {
        width: 100%;
        justify-content: space-between;
    }

    .radio-option {
        flex: 1;
        justify-content: center;
    }
}

@media screen and (max-width:500px){
    .chmHeader{
        background: #fff;
    }
    .chmBanner{
        margin-top:65px;
    }
    .chmTitle{
        color:#333;
        font-size: 18px;
    }
    .fl65{
        display: none;
    }
    .fl15{
        width:40%;
        text-align: right;
    }
    .fl20{
        width:60%;
        text-align: left;
    }
    .chmBannerTop{
        display: none;
    }
    .el-carousel__container{
        height:280px;
    }
    .chmBannerList{
        height:280px;
    }
    .chmBannerList img{
        height:280px;

    }
    .chmJoinUs .chmJoinUsDiv{
        float:left;
        width:100%;
        margin-top:-50px;
    }
    .chmJoinUs .chmJoinUsDiv1{
        border-right:none;
        margin-bottom:100px;
    }
    .flip-card{
        margin:15px 10px;
    }
}
</style>
<style scoped>
.el-menu-group0-item.scrolled {
    color: #333 !important;
}

.el-menu-group0-item.transparent {
    color: #fff !important; /* 覆盖全局的 !important */
}

.imgCode{
    position: absolute;
    width:90px;
    height:33px;
    margin-top:4px;
    margin-left:-90px;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    -webkit-transition-delay: 99999s;
    -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;

}
.fake-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    padding: 0;
    border: none;
}

</style>